import moment from "moment";
import "moment/locale/he"; // 👈 required so Hebrew locale is actually loaded

// Extend (not replace) the English locale
moment.updateLocale("en", {
  calendar: {
    sameDay: "[Today,] MMM D",
    nextDay: "[Tomorrow,] MMM D",
    nextWeek: "ddd, MMM D",
    sameElse: "ddd, MMM D",
  },
});

// Extend the Hebrew locale, keeping Moment’s built-in month/day names
moment.updateLocale("he", {
  calendar: {
    sameDay: "[היום,] D MMMM",
    nextDay: "[מחר,] D MMMM",
    nextWeek: "dddd, D MMMM",
    sameElse: "dddd, D MMMM",
  },
});

export const getDateInfo = (
  dateString: string | null | undefined,
  _?: "en" | "he"
) => {
  if (!dateString) return null;

  const locale = localStorage.getItem("lang") || "en";

  // Set the active locale
  moment.locale(locale);

  const deliveryDate = moment.utc(dateString).startOf("day");
  const today = moment.utc().startOf("day");
  const daysDifference = deliveryDate.diff(today, "days");

  // Example: "Oct 27, 2025" or "27 באוקטובר 2025"
  const formattedDate = deliveryDate.format("D MMMM, YYYY");

  // Example: "Today, Oct 27" or "היום, 27 באוקטובר"
  const deliveryInfo = deliveryDate.calendar();

  // Handle "Delivery in X days" text
  const dayText =
    locale === "en"
      ? daysDifference === 1
        ? "day"
        : "days"
      : daysDifference === 1
      ? "יום"
      : "ימים";

  let deliveryDetail = "";
  if (daysDifference > 0) {
    deliveryDetail =
      locale === "en"
        ? `Delivery in ${daysDifference} ${dayText} (${deliveryDate.format(
            "ddd D"
          )})`
        : `משלוח בעוד ${daysDifference} ${dayText} (${deliveryDate.format(
            "dddd D"
          )})`;
  }

  // Generate friendly custom label (today / tomorrow / weekday)
  let customFormattedDate = "";
  if (daysDifference === 0) {
    customFormattedDate =
      locale === "en"
        ? `Today, ${deliveryDate.format("MMM D")}`
        : `היום, ${deliveryDate.format("D MMMM")}`;
  } else if (daysDifference === 1) {
    customFormattedDate =
      locale === "en"
        ? `Tomorrow, ${deliveryDate.format("MMM D")}`
        : `מחר, ${deliveryDate.format("D MMMM")}`;
  } else {
    customFormattedDate =
      locale === "en"
        ? `${deliveryDate.format("dddd")}, ${deliveryDate.format("MMM D")}`
        : `${deliveryDate.format("dddd")}, ${deliveryDate.format("D MMMM")}`;
  }

  const at = locale === "en" ? "at" : "ב־";
  const on = locale === "en" ? "at" : "ב־";

  const deliveredAt = deliveryDate.format(`MMM D, YYYY [${at}] HH:mm`);
  const cancelledOn = deliveryDate.format(`MMM D, YYYY [${on}] HH:mm`);

  return {
    daysDifference,
    formattedDate,
    deliveryInfo,
    deliveryDetail,
    customFormattedDate,
    deliveredAt,
    cancelledOn,
  };
};
